
let setLoaderVisibility = () => {};

export const showLoader = () => {
  setLoaderVisibility(true);
};

export const hideLoader = () => {
  setLoaderVisibility(false);
};

export const setLoaderController = (controller) => {
  setLoaderVisibility = controller;
};
